import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VCard,[_c(VCardTitle,{directives:[{name:"t",rawName:"v-t",value:('session.card.sessionsByCity'),expression:"'session.card.sessionsByCity'"}]},[_vm._v("Sessions By City")]),_c(VCardText,[_c('bar-chart',{attrs:{"chart-data":_vm.getData}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }